import { loadState } from "./helper/local_storage_helper";
import _ from "lodash";
// Google Analytics init
import ReactGA from 'react-ga';
ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);

const userData = loadState('app_user');
const gameInfo = loadState('game_info');
const prize_trivia_info = _.find(gameInfo, ['GameType', 6]);

// Google Analytics page view logger
export const PageView = () => {
    ReactGA.pageview(window.location.pathname + window.location.search);
}

// Google Analytics Event logger
export const Event = (category, action, label) => {
    ReactGA.event({
        category: category,
        action: action,
        label: label
    });
};

if (userData && userData?.isDummy === "0") {
    ReactGA.set({
        userId: userData.userId ? userData.userId : null,
        phoneNumber: userData.phoneNumber ? userData.phoneNumber : null,
        firstName: userData.firstName ? userData.firstName : null,
        lastName: userData.lastName ? userData.lastName : null,
        // any data that is relevant to the user session
        // that you would like to track with google analytics
    })
}

const metadata = {
    appName: 'Hitmaker',
    status: 'phoneAuth',
    user: userData ? userData : { isUnderage: "0" }
};

export const underage = {
    // Charts: {
    //     Description: 'We\'ll give you last week\'s iHeart Top 40 Music Chart that you can re-order by dragging and dropping songs, and also add new songs. Earn coins towards tickets for more plays!',
    // },
    MusicMatch: {
        Description: 'We\'ll give you 20 matchups of some of the most popular tracks, new singles, and videos alike. It\'s up to you to choose which ones will get the most radio play and YouTube views this week. Earn coins to convert to tickets for more plays!',
    },
};

export const overage = {
    // Charts: {
    //     Description: 'Try to predict next week\'s iHeart top 40 Chart. You start with last week\'s chart that you can re-order by dragging and dropping songs and also adding new ones. You earn points for each correct prediction.',
    // },
    MusicMatch: {
        Description: '<div style="font-size:20px; line-height: 20px; margin-bottom: 5px; font-weight:bold; font-family: ProximaNovaExtrabold;">The Fantasy Football for Music!</div>We give you 20 song matchups. You earn points by picking the songs you think will get the most radio play this week with results every Monday!',
    },
};


export const gameConfig = {
    gameInProgress: false,
    showInvites: false,
    closeGameAlert: false,
    currGame: '',
    Charts: {
        id: 'Charts',
        GameType: 1,
        isOpen: true,
        name: 'Predict the Charts',
        category: 'predictChart',
        path: 'predict-chart',
        Description: (NoOFItems) => `Try to predict next week's iHeart top ${NoOFItems} Chart. You start with last week's chart that you can re-order by dragging and dropping songs and also adding new ones. You earn points for each correct prediction.`,
        ruleLink: 'https://res.hitmakerapp.com/hitmaker-predict-the-charts-contest-official-rules/',
        shareContent: 'Join me on Hitmaker. I made my picks for what hit singles will make the iHeart Top 40 Charts and now it’s your turn. Listen to the songs, make your predictions, and win big.',
        StartNewGame: false,
        label: 'Pick next Week\'s iHeart Top 40 Charts',
        genreType: 0,
        JackpotPrize: 100000,
        topScorePrize: '$25',
        NoOfEntries: 0,
        Data: {
            Items: [],
            gameState: {
                screen: 'chartGame'
            }
        }
    },
    MusicMatch: {
        id: 'MusicMatch',
        GameType: 2,
        isOpen: true,
        name: 'Music Match Up',
        category: 'musicMatch',
        Description: '',
        path: 'music-match',
        ruleLink: 'https://res.hitmakerapp.com/music-match-official-contest-rules/',
        shareContent: 'Join me on Hitmaker. I made my picks for what hit singles will chart higher on the iHeart Top 40 and now it’s your turn. Listen to the songs, make your predictions, and win big.',
        StartNewGame: false,
        label: 'Predict which song will get the most radio play this week + Youtube views & other play choices',
        genreType: 0,
        JackpotPrize: 250,
        topScorePrize: '$25',
        NoOfEntries: 0,
        Data: {
            Items: [],
            BonusQuestions: [],
            currPickedItems: [],
            bonus: [],
            gameState: {
                screen: 'lineup',
                currMatchIndex: 0,
                IsSubmitted: false,
                bonusInterval: 10,
                bonusIntervalLength: 2,
                bonusCount: 0,
                totalBoosts: 3,
            }
        }
    },
    AwardShow: {
        id: 'AwardShow',
        GameType: 7,
        isOpen: false,
        name: 'Predict the Award Show',
        category: 'awardShow',
        path: 'predict-awards',
        Description: (val) => `Take a look at the nominees and predict who you think will win in each category! Get them all right and you could win ${val}!`,
        ruleLink: 'https://res.hitmakerapp.com/hitmaker-predict-the-charts-contest-official-rules/',
        shareContent: '',
        StartNewGame: false,
        label: 'Predict which nominee will win their respective category in a verity of award shows',
        JackpotPrize: 100000,
        topScorePrize: '$25',
        NoOfEntries: 0,
        Data: {
            Categories: [],
            currPickedItems: [],
            gameState: {
                screen: 'radioAwards'
            }
        }
    },
    PrizeTrivia: {
        id: 'PrizeTrivia',
        GameType: 6,
        isOpen: true,
        name: 'Prize Trivia',
        category: 'prizeTrivia',
        Description: `Play Music Trivia from the top 40 and beyond with new questions every time you play! The faster you answer, the more points you get! <div class="mt-2">The top score of each week wins their choice  between  ${prize_trivia_info ? `$${prize_trivia_info?.TopScorePrize}` : '$50'} or signed memorabillia from your favorite artists!</div>`,
        path: 'prize-trivia',
        shareContent: '',
        ruleLink: 'https://res.hitmakerapp.com/prize-trivia-official-contest-rules/',
        genreType: 0,
        JackpotPrize: 250,
        topScorePrize: '$25',
        NoOfEntries: 0,
    },
    MusicTrivia: {
        id: 'MusicTrivia',
        GameType: 5,
        isOpen: true,
        name: 'Trivia',
        category: 'musicTrivia',
        Description: 'Play Music Trivia from your choice of genre with new questions everytime you play! <br /> The faster you answer, the more points you get! <div style="margin-top: 10px">You\'ll earn coins to get tickets to play the Prize Games!</div>',
        path: 'bonus',
        shareContent: '',
        ruleLink: '',
        genreType: 0,
    }
}

export default () => ({
    metadata,
    gameConfig
});